import "./intro.css"

function Explanation () {
    return (
        <>
        <div >
        {/* <p className="explanation"> 
             Ankara Condensed Matter Colloquia is a colloquium 
            series aimed at an audience of starting graduate 
            or advanced undergraduate students. Its primary aim is to provide a 
            pedagogical introduction to the cutting edge research areas in all fields 
            of both theoretical and experimental condensed matter physics research. 
            The first set of talks cover a wide range of subfields, including (but not limited to)
            many-body theory, quantum computation, topology and exotic magnetism. 

        </p> */}
        <p className="details">
            Talks will be online via Zoom on <em>Tuesdays 7:00 pm </em> (local Ankara time).
        </p>
        <p className="zoom_details">
        <a className="zoomlink" href="https://zoom.us/j/4329316595?pwd=bW5CZ2NDc1VTbVRuc292UkVmRWlWUT09" target="_blank" rel="noopener noreferrer"> Zoom Link </a>
        </p>
        <p className="zoom_details">
            <p>Meeting ID : 432 931 6595</p> 
            <p>Password : 326852</p>
        </p>
        <p className="thanks">
            We thank the physics departments of Ankara, Bilkent, Gazi, Hacettepe, and 
            Middle East Technical Universities for their support. 
        </p>

        </div>
        </>

    )
}

export default Explanation